//import react from 'react'

const Logo = () => (
  <img alt="Logo" height="60px" src="/enjazPLogoTransparent.png" />
);

export default Logo;
